import { IEnrichedActivityGroup } from '../components/ActivityGroup/types';
import { IInAppSystemNotification } from './useInAppSystemNotifications';

export type IStreamNotificationItem = {
  enrichedActivityGroup: IEnrichedActivityGroup;
  markRead: () => Promise<void>;
};

export type IUnifiedNotificationItem =
  | {
      kind: 'stream';
      id: string;
      date: string;
      streamItem: IStreamNotificationItem;
    }
  | {
      kind: 'system';
      id: string;
      date: string;
      notification: IInAppSystemNotification;
    };

export const mergeNotificationItems = (options: {
  streamItems: IStreamNotificationItem[];
  systemNotifications: IInAppSystemNotification[];
}): IUnifiedNotificationItem[] => {
  const streamItems: IUnifiedNotificationItem[] = options.streamItems.map(
    (streamItem) => ({
      kind: 'stream' as const,
      id: streamItem.enrichedActivityGroup.id,
      date: streamItem.enrichedActivityGroup.updated_at,
      streamItem,
    })
  );
  const systemItems: IUnifiedNotificationItem[] =
    options.systemNotifications.map((notification) => ({
      kind: 'system' as const,
      id: notification._id,
      date: notification.dateCreated || new Date(0).toISOString(),
      notification,
    }));

  return [...systemItems, ...streamItems].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );
};
